<template>
    <div :class="`form-group col-${width}`">
        <label>{{ label }}</label>
        <flat-pickr class="form-control" v-model="model"></flat-pickr>
    </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import moment from 'moment'
  
export default {
    props: ['label', 'model', 'width'], 
    data() {
        return {
            date: null,       
        }
    },
    components: {
        flatPickr
    }
}
</script>